import React, { useState, useEffect } from "react";
import PageHeader from "../../../components/styled/PageHeader";
import { Typography } from "@plum-xoxo/admin-dsm";
import TableComponent from "./TableComponent";
import ProformaInvoice from "../../../components/Modals/ProformaInvoice";
import { getEnabledModules } from "../utils/getEnabledModules";
import { getContentWrapperClass } from "../../../utils/header";
import { getReportsOptions } from "../../../components/Sidebar/constants";
import OptionSideBar from "../../../components/Sidebar/OptionSideBar";
import profileService from "../../../services/profileService";

const Reports = ({
  accountReducer,
  plumPro,
  history,
  initialData,
  initialFetchParams,
  isFirstRewardSent,
  type = "",
  updateEmployeeDetails,
}) => {
  let initialActiveTab = 0;
  if (history?.location?.title) {
    initialActiveTab = initialData.findIndex(
      (data) =>
        data?.title?.toLowerCase() === history?.location?.title?.toLowerCase()
    );
    if (initialActiveTab === -1) {
      initialActiveTab = 0;
    }
  }

  const [activeTab, setActiveTab] = useState(initialActiveTab || 0);
  const [showProformsSuccess, setShowProformsSuccess] = useState(false);
  const [employeeEmail, setEmployeeEmail] = useState("");

  useEffect(() => {
    const response = history.location.state
      ? JSON.parse(history.location.state)
      : "";
    setShowProformsSuccess(response?.showProformsSuccess);
    setEmployeeEmail(response?.employee_email);
    window.history.replaceState({}, document.title);
    fetchAdminDetails();
  }, []);

  const { enabledModules } = getEnabledModules(accountReducer);
  const visibleModulesList = enabledModules.filter((module) => module.enable);
  let showBackButton = true;
  if (visibleModulesList.length === 1) {
    showBackButton = false;
  }

  const fetchAdminDetails = () => {
    profileService
      .adminDetails({})
      .then((response) => {
        if (response && response.fetchUserDetails) {
          let userDetails = {
            timeZone: response.fetchUserDetails.timeZone || "",
            employee_first_name: response.fetchUserDetails.first_name || "",
            employee_last_name: response.fetchUserDetails.last_name || "",
            employee_email: response.fetchUserDetails.email || "",
            employee_primary_mobile: response.fetchUserDetails.contact || "",
            platform: response.fetchUserDetails.platform || "",
            domain: response.fetchUserDetails.domain || "",
          };
          userDetails.employee_full_name = userDetails.employee_first_name;
          userDetails.employee_full_name += userDetails.employee_first_name
            ? " " + userDetails.employee_last_name
            : userDetails.employee_last_name;
          updateEmployeeDetails(userDetails);
        }
      })
      .catch(() => {
        //this.setState({ loader: false });
      });
  };
  const options = getReportsOptions(initialData, type?.replaceAll("_", "-"));

  return (
    <>
      <OptionSideBar
        title="Reports"
        options={options}
        onClick={(i) => {
          setActiveTab(i);
        }}
        accountReducer={accountReducer}
        isFirstRewardSent={isFirstRewardSent}
      />
      <div
        className={`${getContentWrapperClass({
          accountReducer,
          isFirstRewardSent,
        })}`}
        style={{
          overflow: "scroll",
        }}
      >
        <PageHeader
          title={options[activeTab]?.title + " Reports"}
          className="mt-0 mb-16"
          showBackButton={showBackButton}
        />
        {showProformsSuccess ? (
          <ProformaInvoice
            headerTitle=""
            headerClass="d-none"
            proformaBody={
              <div className="text-left">
                <img src="/admin/img/svg-icons/icon-success-large.svg" />
                <Typography.H2 color="dark" shade="c300" className="my-12">
                  Invoice generated successfully
                </Typography.H2>
                <Typography color="dark" shade="c200">
                  Your invoice has been generated and sent to {employeeEmail}.
                </Typography>
              </div>
            }
            modalStatus={() => {
              setShowProformsSuccess(false);
            }}
            disableCross={false}
            topMargin="mt-48"
            buttonText="OK, Got It"
            actionProformaHandler={() => {
              setShowProformsSuccess(false);
            }}
            className="actionModalFooterRight pb-0"
          />
        ) : null}

        {initialData.map((tab, i) =>
          activeTab === i ? (
            <TableComponent
              key={i}
              tableData={initialData[activeTab]}
              activeTab={activeTab}
              initialFetchParams={initialFetchParams}
              accountReducer={accountReducer}
              plumPro={plumPro}
              type={type}
              history={history}
              isFirstRewardSent={isFirstRewardSent}
            />
          ) : null
        )}
      </div>
    </>
  );
};

export default Reports;
